import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookGraphS1Service } from './taf-book-graph-s1.service';
import { ITafBookElemGraphS1 } from './taf-book-graph-s1';

import { UIChart} from 'primeng/primeng';
import * as _ from 'lodash';

/*steps to install lodash:
npm install typings --global
With older versions of typings things mess up and you'll get a bunch of "Duplicate identifier" issues. Also you don't need to use --ambient anymore as far as I could tell.

So once typings is up to date, this should work (using the Angular 2 quickstart).

Run:

npm install lodash --save 
typings install lodash --save
First, add this to systemjs.config.js:

'lodash':                     'node_modules/lodash/lodash.js'
 */
@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-graph-s1/taf-book-graph-s1.component.html',
     template: require('./taf-book-graph-s1.component.html'),
    directives: [ROUTER_DIRECTIVES, UIChart]
    
})

export class TAFBookGraphS1Component implements OnInit, OnDestroy{
   
    pageTitle: string = 'TAF BOOK Graph S1';
    errorMessage: string;
    tafBookGraphS1Arr: any;
    tafBookGraphS1ArrLocid: any[];
    tafBookGraphS1ArrRate : any[];
    data : any;
    options: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookGraphS1Service: TAFBookGraphS1Service) {
    }
    ngOnInit(): void{
        this._tafBookGraphS1Service.getTAFGraphS1BookSplit()
         .subscribe(
             tafBookGraphS1Arr => this.tafBookGraphS1Arr = tafBookGraphS1Arr,
                error=>console.log("Error", error),
                ()=>{ 
                    this.tafBookGraphS1ArrLocid = _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'locid');
                    this.tafBookGraphS1ArrRate = _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'rateFyLfc');
                    //console.log("mapxAxis Component: " +this.tafBookGraphS1ArrLocid);// _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'locid')
                    //console.log("mapyAxis Component: " +  _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'rateFyLfc'));
                    this.data = {
                            labels: this.tafBookGraphS1ArrLocid,
                            datasets: [
                                {
                                    label: 'Growth Rate',
                                    data: this.tafBookGraphS1ArrRate
                                }
                            ]
                        }
                    this.options = {
                                    legend: {
                                        display: false,
                                        position: 'bottom'
                                    },
                                    scales: {
                                        xAxes: [{
                                               scaleLabel: {
                                                    display: true,
                                                    labelString: 'Airport'
                                           }
                                        }],
                                        yAxes: [{
                                            scaleLabel: {
                                                    display: true,
                                                    labelString: 'Annual Growth Rate'
                                           }
                                        }]
                                    }
                                };

                    }
                );
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-graph-s1/taf-book-graph-s1.component.ts
 **/